import React, { useRef, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { TopNotification } from "./Notification";

function RecoverAccount() {
  const [error, setError] = useState();
  const emailRef = useRef();
  const [loading, setLoading] = useState(false);
  const { recoverAccount } = useAuth();

  const handleRecoverAccount = (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const result = formValidation(emailRef.current.value);
      if (!result) {
        console.log(result);
        setLoading(false);
        return;
      }

      recoverAccount(emailRef.current.value).then((response) => {
        if (response === "hatalı giriş") {
          setError("Hatalı e-posta");
        } else {
          setError("E-postanızı kontrol edin");
        }
      });
    } catch {
      console.log("failed to send recovery email");
    }
    setLoading(false);
  };

  const formValidation = (email) => {
    var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (!email.match(mailformat)) {
      setError("Geçersiz e-posta");
      return false;
    }
    return true;
  };

  return (
    <div className="login">
      <div className="login__container recover__container">
        <form onSubmit={handleRecoverAccount} className="login__form">
          {error && <TopNotification notification={error} color={"red"} />}
          <h1>SIFREMI UNUTTUM</h1>
          <div className="h5">
            <h5>E-posta</h5>
          </div>
          <div className="input">
            <input type="email" ref={emailRef} required />
          </div>
          <div className="register__buttons">
            <div className="button">
              <button
                disabled={loading}
                type="submit"
                className="login__signInButton"
              >
                GONDER
              </button>
            </div>
          </div>
          <div className="topLeftBorder">
            <div>
              <div className="borderTop"></div>
              <div className="borderLeft"></div>
            </div>
          </div>
          <div className="bottomRigtBorder">
            <div>
              <div className="borderRight"></div>
              <div className="borderBottom"></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RecoverAccount;
